import React from 'react';

/*
 * A plain play glyph. PlayIcon is a whole button - a filled circle with its own
 * blue baked in - which cannot sit inside one.
 */
const PlayTriangleIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24"
         fill={props.fill ? props.fill : 'currentColor'}
    >
        <path d="M8 5.14v13.72a1 1 0 0 0 1.52.85l11.14-6.86a1 1 0 0 0 0-1.7L9.52 4.29A1 1 0 0 0 8 5.14z"/>
    </svg>
);

export default PlayTriangleIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/PlayTriangleIcon.jsx